"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.terminalGeneratePINForUser = void 0;
const create_ac_1 = require("@app/ac/util/create-ac");
const terminal_generate_pin_for_user_1 = require("../request/terminal-generate-pin-for-user");
const user_details_1 = require("@app/reducer/user-details");
exports.terminalGeneratePINForUser = (0, create_ac_1.createAC)(async (dispatch, { workspaceId, userId, useEmployeeId }) => {
    const res = await (0, terminal_generate_pin_for_user_1.mutateTerminalGeneratePINForUser)({ workspaceId, userId, useEmployeeId });
    dispatch((0, user_details_1.setUserTerminalPIN)(res));
});
